import moment from 'moment';

export const getFormattedDateRange = (fromDate, toDate) => {
    let currentDate = new Date();
    if (!fromDate) return ["", ""];
    return [
        moment(fromDate).format('YYYYMMDD'),
        toDate ? moment(toDate).format('YYYYMMDD'): moment(currentDate).format('YYYYMMDD')
    ];
};
